import React, { useState, useRef, useEffect } from "react";
import { Eye, ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function PreviewMenuButton({ onPreview }) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (!ref.current) return;
      if (!ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onDoc);
    return () => document.removeEventListener("click", onDoc);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(v => !v)}
        className="bg-emerald-600 rounded-lg px-4 py-2 text-white hover:bg-emerald-700 inline-flex items-center gap-2"
      >
        <Eye className="w-4 h-4" />
        {t("exam_builder.preview")}
        <ChevronDown className="w-4 h-4 opacity-80" />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-56 bg-white border rounded-xl shadow-lg overflow-hidden z-10">
          <button
            className="w-full text-left px-4 py-2 hover:bg-gray-50"
            onClick={() => { setOpen(false); onPreview?.("full"); }}
          >
            {t("exam_builder.preview_full")}
          </button>
          <button
            className="w-full text-left px-4 py-2 hover:bg-gray-50"
            onClick={() => { setOpen(false); onPreview?.("device"); }}
          >
            {t("exam_builder.preview_device")}
          </button>
        </div>
      )}
    </div>
  );
}
